import * as React from "react";
import { useEffect, useState } from "react";
import { CircularProgress, Dialog, styled } from "@mui/material";
import { ClinicFormInput } from "../elements/clinicFormInput";
import { ClinicActionButton } from "fe-web-components/clinic/clinicActionButton";
//import FormControlCheckbox from "../../../themeComponents/FormControlCheckbox";
import { useClinicContext } from "fe-web-components/clinic/ClinicContext";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// import { CLINIC_BASE_URL } from "../clinicSettings/clinicUrls";
//region [[ Styles ]]

const RenameClinicDialogView = styled(Dialog)({
  "& .MuiDialog-paperWidthXl": { padding: 20 },
});

const StatusIconContainer = styled("div")({
  width: "18px",
  height: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&.error svg": {
    fill: "lightpink",
  },
  "&.success svg": {
    fill: "lightgreen",
  },
});

const Footer = styled("div")({
  textAlign: "center",
});
//endregion [[ Styles ]]

//region [[ Props ]]
const MAX_CLINIC_NAME_LENGTH = 32;

export interface RenameClinicDialogProps {
  clinicId?: string;
  open?: boolean;
  onClose?: () => void;
  onSubmit: (id, newWebName, newDisplayName) => void;
  initialUrlName: string;
  initialDisplayName: string;
  inline?: boolean;
  errorText?: string;
  label?: string;
  dontUpdateOnSubmit?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const RenameClinicDialog = ({
  initialUrlName,
  ...props
}: RenameClinicDialogProps) => {
  const dao = useClinicContext();

  const [name, setName] = useState(initialUrlName);
  const [displayName, setDisplayName] = useState(props.initialDisplayName);
  const [errorText, setErrorText] = useState<string>(null);
  //const [syncNames] = useState(true);
  const [loading, setLoading] = useState(false);
  const [checkingUrlName, setCheckingUrlName] = useState(false);
  const [nameIsValid, setNameIsValid] = useState(true);

  const onChangeClinicName = (e) => {
    const newDisplayName = e.target.value;
    setDisplayName(newDisplayName);

    if (newDisplayName.length > MAX_CLINIC_NAME_LENGTH) {
      setNameIsValid(false);
      setErrorText(`Clinic name exceeds ${MAX_CLINIC_NAME_LENGTH} characters`);
      return;
    }
    setName(
      encodeURIComponent(newDisplayName.trim().toLowerCase())
        .replaceAll("%20", "_")
        .toLowerCase(),
    );
  };

  // const onChangeClinicUrlName = (e) => {
  //   setName(e.target.value);
  // };

  useEffect(() => {
    setErrorText(null);
    setNameIsValid(true);
    if (!name || name === initialUrlName) return;
    // if (!name) {
    //   setNameIsValid(false);
    //   setErrorText("Can not be empty");
    //   return;
    // }

    setCheckingUrlName(true);
    dao.isClinicWebNameAvailable(name).then((res) => {
      setCheckingUrlName(false);
      if (res) {
        setErrorText(null);
        setNameIsValid(true);
      } else {
        setNameIsValid(false);
        setErrorText("Clinic name is already taken. Please try another name.");
      }
    });
  }, [dao, name, initialUrlName]);

  const renameClinic = async () => {
    if (errorText || !displayName || displayName === "") {
      setErrorText("Please fill in a display name");
      setLoading(false);
      return;
    }
    // If inline don't rename
    if (props.dontUpdateOnSubmit) {
      props.onSubmit(null, name, displayName);
    }
    setLoading(true);
    const ret = await dao.renameClinic(props.clinicId, name, displayName);
    if (!ret) {
      setErrorText("Failed updating clinic name");
    }
    setErrorText(null);
    setLoading(false);
    props.onSubmit(props.clinicId, name, displayName);
  };

  const renderContent = () => (
    <>
      <ClinicFormInput
        label={"Clinic Name"}
        value={displayName}
        onChange={onChangeClinicName}
        error={errorText}
        placeHolder={"Enter a name"}
        inputSuffix={
          displayName &&
          (checkingUrlName ? (
            <CircularProgress size={16} />
          ) : (
            <StatusIconContainer className={nameIsValid ? "success" : "error"}>
              {nameIsValid ? <CheckCircleIcon /> : <HighlightOffIcon />}
            </StatusIconContainer>
          ))
        }
      />
      {/*<SyncCheckbox*/}
      {/*  checked={syncNames}*/}
      {/*  text={"Assign automatically"}*/}
      {/*  onChange={(state) => setSyncName((old) => !old)}*/}
      {/*/>*/}
      {/*<ClinicFormInput*/}
      {/*  label={"Clinic URL"}*/}
      {/*  value={name}*/}
      {/*  onChange={onChangeClinicUrlName}*/}
      {/*  inputPrefix={CLINIC_BASE_URL}*/}
      {/*  disabled={checkingUrlName || syncNames}*/}
      {/*>*/}
      {/*  <>*/}
      {/*    {checkingUrlName && <CheckingUrlProgress size={16} />}*/}
      {/*    {!checkingUrlName && (*/}
      {/*      <StatusIconContainer className={nameIsValid ? "success" : "error"}>*/}
      {/*        {nameIsValid ? <CheckCircleIcon /> : <HighlightOffIcon />}*/}
      {/*      </StatusIconContainer>*/}
      {/*    )}*/}
      {/*  </>*/}
      {/*</ClinicFormInput>*/}
      <Footer>
        <ClinicActionButton
          className="submit-button"
          onClick={renameClinic}
          label={props.label || "Create"}
          disabled={loading || checkingUrlName || !displayName || !nameIsValid}
          endIcon={loading && <CircularProgress size={20} />}
        />
      </Footer>
    </>
  );

  if (props.inline) {
    return renderContent();
  }

  return (
    <RenameClinicDialogView
      open={props.open}
      onClose={props.onClose}
      maxWidth={"xl"}
    >
      {renderContent()}
    </RenameClinicDialogView>
  );
};
